import React                  from 'react'
import {connect}              from 'react-redux';
import Img1                   from '../../../img/recursos/dados.png';
import Img2                   from '../../../img/recursos/progressivo.png';
import Img3                   from '../../../img/recursos/regressivo.png';
import {Config}               from '../../../actions/configActions';
import { GetListaMenuTopo,
         GetListaSubMenuTopo} from '../../../actions/scopoAction';

class Recursos extends React.Component {

    componentWillMount() {

        this.props.GetListaMenuTopo([
            {action:true,nome:"Home",link:this.props.menu.home},
            {action:false,nome:this.props.menu.recursos.nomeModulo}
           ]);

        this.props.GetListaSubMenuTopo([]);
    }

    menuRecursos(id){
      

        switch (id) {
            case 1:
                   return `${Config().ip}/animacoes/dados/index.html`;
            break;

            case 2:
                 return `${Config().ip}/animacoes/progressivo/index.html`;
            break;

            case 3:
              return `${Config().ip}/animacoes/regressivo/index.html`;
            break;
        
            default:

            alert('Não existe nenhum recursos cadastro com esse ID.')
            break;
        }

    }

    popUp(id){
        
                window.open(this.menuRecursos(id), "_blank", "toolbar=yes, scrollbars=yes, resizable=yes, top=100, left=200, width=550, height=350");
            }

    render() {
        return (
            <div>
            <div className="container-bg">
                    <div className="row">
                        <div className="conteudo-recursos">
                            <div className="col-xs-6 col-md-4">
                                <a href={void(0)}  className="thumbnail" onClick={this.popUp.bind(this,1)}>
                                    <img alt="Fruit Ninja" data-src="holder.js/100%x180" src={Img1} data-holder-rendered="true"></img>
                                </a>
                            </div>
                            <div className="col-xs-6 col-md-4">
                                <a href={void(0)}  className="thumbnail" onClick={this.popUp.bind(this,2)}>
                                    <img alt="Fruit Ninja" data-src="holder.js/100%x180" src={Img2} data-holder-rendered="true"></img>
                                </a>
                            </div>
                            <div className="col-xs-6 col-md-4">
                                <a href={void(0)}  className="thumbnail" onClick={this.popUp.bind(this,3)}>
                                    <img alt="Fruit Ninja" data-src="holder.js/100%x180" src={Img3} data-holder-rendered="true"></img>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>      
        );
    }
}

function mapStateToProps(state){

    return {
            session : state.auth.session,  
            menu    : state.configReducer.menu
           }
}


export default connect(mapStateToProps,{ 
    GetListaMenuTopo,
    GetListaSubMenuTopo
   })(Recursos); 




// WEBPACK FOOTER //
// ./src/components/professor/recursos/recursos.js